import { difference } from 'lodash-es';

export class PartialConversion extends Error {
  constructor(public object: unknown, public missingKeys: string[]) {
    super(`Missing keys [${missingKeys.join(', ')}] in object`);
  }
}


/**
 * This is a typeguard for checking that a type has a set of given keys.
 *
 * Warning: This is not typesafe. It is just preferrable to an `as T` cast.
 */
export function typeGuardPartial<T>(...required: ((keyof T) & string)[]) {
  return (partial: Partial<T>): partial is T => {
    return required.every(req => req in partial);
  };
}


/**
 * Warning: This is not typesafe. It is just preferrable to an `as T` cast.
 */
export function fromPartialOrFail<T>(...required: ((keyof T) & string)[]) {
  return (partial: Partial<T>): T => {
    if (!typeGuardPartial<T>(...required)(partial)) {
      throw new PartialConversion(partial, difference(required, Object.keys(partial)));
    }
    return partial;
  };
}
